import React, { useCallback, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { alertasApi, errorMsg } from './alertasObra.api';
import { formatearTelefono } from './AlertasObra';

/* 🚚 Entregas › ¿A quién le aviso?: qué números de esta obra reciben «Llegó material a la obra».
   Es el mismo dato de siempre (alertConfigs.obras[].alertas.entregas, por número); los números se suman en 🏗️ Obra. */

function Switch({ on, onChange, disabled, label }) {
  return (
    <button type="button" role="switch" aria-checked={!!on} aria-label={label} disabled={disabled} onClick={() => onChange(!on)}
      className={`w-11 h-6 flex items-center rounded-full p-1 transition-colors shrink-0 ${on ? 'bg-blue-600' : 'bg-gray-300'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <span className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${on ? 'translate-x-5' : 'translate-x-0'}`} />
    </button>
  );
}

export default function EntregasDestinatarios({ feedID, onIrAObra }) {
  const [datos, setDatos] = useState(null);
  const [ocupado, setOcupado] = useState(null);
  const cargar = useCallback(() => { alertasApi.listar(feedID).then(setDatos).catch(() => setDatos({ configs: [], error: true })); }, [feedID]);
  useEffect(() => { if (feedID) cargar(); }, [feedID, cargar]);

  const cambiar = async (c, patch) => {
    setOcupado(c.phone);
    try {
      const e = { ...(c.obra?.alertas?.entregas || {}), ...patch };
      const r = await alertasApi.guardar(c.phone, feedID, { obra: { alertas: { entregas: e } } });
      setDatos((d) => ({ ...d, configs: d.configs.map((x) => (x.phone === c.phone ? r : x)) }));
      if ('activo' in patch) toast.success(patch.activo ? `${formatearTelefono(c.phone)} va a recibir los avisos de entregas.` : 'Listo, ese número ya no recibe avisos de entregas.');
    } catch (err) { toast.error(errorMsg(err)); }
    setOcupado(null);
  };

  if (!datos) return <div className="flex items-center gap-2 text-sm text-gray-500 mt-4"><Loader2 size={15} className="animate-spin" />Cargando…</div>;
  const configs = datos.configs || [];
  return (
    <div className="mt-4 pt-4 border-t border-gray-100" data-entregas-destinatarios>
      <h4 className="text-sm font-semibold text-gray-800">¿A quién le aviso?</h4>
      <p className="text-xs text-gray-500 mb-2">Prendé los números que tienen que enterarse cuando llega material.</p>
      {!configs.length ? (
        <div className="text-xs text-gray-600 bg-gray-50 rounded-xl px-3 py-2.5 flex items-center justify-between gap-2 flex-wrap">
          <span>Todavía no hay números en esta obra.</span>
          {onIrAObra && <button type="button" onClick={onIrAObra} className="font-semibold text-blue-700 hover:underline">Sumar un número en 🏗️ Obra</button>}
        </div>
      ) : (
        <div className="space-y-2">
          {configs.map((c) => {
            const e = c.obra?.alertas?.entregas || {};
            const on = !!e.activo;
            return (
              <div key={c.phone} className={`rounded-xl border p-3 flex items-center gap-3 flex-wrap ${on ? 'border-emerald-200 bg-emerald-50/40' : 'border-gray-200 bg-white'}`}>
                <span className="text-lg" aria-hidden="true">📱</span>
                <span className="text-sm font-semibold text-gray-800 flex-1 min-w-[9rem] truncate">{formatearTelefono(c.phone)}</span>
                {on && (
                  <select value={e.canal || 'ambos'} disabled={ocupado === c.phone} onChange={(ev) => cambiar(c, { canal: ev.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs bg-white" aria-label="Canal">
                    <option value="ambos">WhatsApp y mail</option>
                    <option value="wsp">Solo WhatsApp</option>
                    <option value="mail">Solo mail</option>
                  </select>
                )}
                {ocupado === c.phone ? <Loader2 size={16} className="animate-spin text-gray-400" /> : <Switch on={on} label={`Avisos de entregas a ${c.phone}`} onChange={(v) => cambiar(c, { activo: v })} disabled={!datos.entregasHabilitado && !on} />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
